export default {
  bagFees: 'Ytterligare bagageavgifter kan tillkomma',
}
